import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    minWidth: 440,
    paddingTop: 8
  },
  field: {
    maxWidth: 420
  },
  hint: {
    color: '#6b7280'
  },
  actions: {
    display: 'flex',
    gap: 12,
    marginTop: 8
  }
});
export default useStyles;